import Vue from 'vue'
import VShowSlide from 'v-show-slide'

Vue.use(VShowSlide)
